import cn from 'classnames';
import React, { useEffect } from 'react';

// REDUX
import { getGlobalStyles, getTurboModeState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES

//BUTTONS
import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';
import { Button } from '@UILayer/Inputs/Button';
import { useTranslation } from 'react-i18next';

const AutoPlayPanelGameSpeedSelector: React.FC<{ fontSize: React.CSSProperties }> = ({ fontSize }) => {
    const globalStyles = useAppSelector(getGlobalStyles);
    const gameStoreTurboModeState = useAppSelector(getTurboModeState);

    const { t } = useTranslation();
    const classes = cn(styles.game_speed_selector_container, globalStyles.orientation, globalStyles.handMode);

    useEffect(() => {}, []);

    const TurboSpeeds: Array<{ name: string; level: number }> = [
        { name: t('GAME_SPEED_NORMAL'), level: 0 },
        { name: t('GAME_SPEED_FAST'), level: 1 },
        { name: t('GAME_SPEED_TURBO'), level: 2 }
    ];

    function setTurboMode(level: number) {
        if (level !== gameStoreTurboModeState.baseGameLevel) EventsCenter.emit(EButtonEvents.AUTO_TURBO_BUTTON_PRESSED, { level: level });
    }

    return (
        <>
            <div className={classes}>
                {TurboSpeeds.map((item, index) => (
                    <Button
                        style={fontSize}
                        key={index}
                        id={`ui_button_turbo_option_${item.name}`}
                        description={`${t('WCA_SET_GAME_SPEED_TO')} ${item.name}`}
                        className={cn(styles.game_speed_button, globalStyles.wcaMode, {
                            [styles.active]: gameStoreTurboModeState.baseGameLevel === item.level ? true : false
                        })}
                        onChange={() => setTurboMode(item.level)}
                        focus={index === 0 ? true : false}
                    >
                        {item.name}
                    </Button>
                ))}
            </div>
        </>
    );
};

export default AutoPlayPanelGameSpeedSelector;
